module.exports = __webpack_public_path__ + "static/media/init_sound.e48fd523.wav";